import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const QuestionMark = ({
  size,
  type,
  theme,
  className,
  dataTestId = "question-mark-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M7.07765 5.44224C6.91162 5.57379 6.80396 5.76413 6.75839 6.02491C6.69501 6.38761 6.34961 6.63025 5.98692 6.56687C5.62422 6.50349 5.38158 6.15809 5.44496 5.7954C5.5354 5.27784 5.77958 4.76962 6.2496 4.39719C6.71589 4.02772 7.33558 3.84635 8.07824 3.84635C8.86773 3.84635 9.50792 4.04017 9.95496 4.44909C10.4093 4.86466 10.5661 5.41222 10.5661 5.91016C10.5661 6.95347 9.86133 7.56299 9.50929 7.86747C9.46746 7.90364 9.43058 7.93555 9.40049 7.96332C9.30482 8.05163 9.19245 8.14237 9.09587 8.22036L9.04541 8.26117C8.92949 8.35524 8.82667 8.44132 8.73495 8.53148C8.56788 8.69571 8.47894 8.83413 8.44508 8.96893V9.2003C8.44508 9.56849 8.1466 9.86697 7.77841 9.86697C7.41022 9.86697 7.11174 9.56849 7.11174 9.2003V8.84789L7.12076 8.79362C7.21147 8.24773 7.52184 7.85431 7.80026 7.58062C7.94024 7.44302 8.08508 7.32336 8.20524 7.22585L8.26669 7.17609C8.3642 7.0972 8.43566 7.03938 8.49611 6.98358C8.54723 6.9364 8.5961 6.89205 8.64261 6.84985C9.01293 6.51382 9.23274 6.31436 9.23274 5.91016C9.23274 5.68652 9.16719 5.53552 9.05502 5.43291C8.93558 5.32365 8.66519 5.17969 8.07824 5.17969C7.548 5.17969 7.24742 5.30772 7.07765 5.44224Z" />
    <path d="M8.79072 11.34C8.79072 11.8492 8.37793 12.262 7.86872 12.262C7.35952 12.262 6.94673 11.8492 6.94673 11.34C6.94673 10.8308 7.35952 10.418 7.86872 10.418C8.37793 10.418 8.79072 10.8308 8.79072 11.34Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8Z"
    />
  </SVGIcon>
);
